import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './End.st.css.js';
class End extends React.PureComponent {
    static { this.propTypes = {
        children: PropTypes.node,
    }; }
    render() {
        const { children } = this.props;
        return React.createElement("div", { className: classes.end }, children);
    }
}
export default End;
//# sourceMappingURL=End.js.map